export const TKeyAffiliation = {
  AFFILIATIONS: "AFFILIATIONS",
  AFFILIATION_NO_PROGRAM: "AFFILIATION_NO_PROGRAM",
  AFFILIATION_DESCRIPTION: "AFFILIATION_DESCRIPTION",
  AFFILIATION_REFERRALS: "AFFILIATION_REFERRALS",
  AFFILIATION_TOTAL_GENERATED: "AFFILIATION_TOTAL_GENERATED",
  AFFILIATION_PAYOUT_LABEL: "AFFILIATION_PAYOUT_LABEL",
  AFFILIATION_PAYOUT_TO_PAY: "AFFILIATION_PAYOUT_TO_PAY",
  AFFILIATION_PAYOUT_RECORD: "AFFILIATION_PAYOUT_RECORD",
  AFFILIATION_PAYOUT_OWED: "AFFILIATION_PAYOUT_OWED",
  AFFILIATION_PAYOUT_AMOUNT: "AFFILIATION_PAYOUT_AMOUNT",
  AFFILIATION_PAYOUT_INVOICE: "AFFILIATION_PAYOUT_INVOICE",
  AFFILIATION_PAYOUT_INVOICE_PLACEHOLDER: "AFFILIATION_PAYOUT_INVOICE_PLACEHOLDER",
  AFFILIATION_PAYOUT_CONFIRM: "AFFILIATION_PAYOUT_CONFIRM",
  AFFILIATION_ALREADY_PAID: "AFFILIATION_ALREADY_PAID",
  AFFILIATION_PAYOUT_BELOW: "AFFILIATION_PAYOUT_BELOW",
  AFFILIATION_PAYOUT_READY: "AFFILIATION_PAYOUT_READY",
  AFFILIATION_HOURS_UNIT: "AFFILIATION_HOURS_UNIT",
  AFFILIATION_COMMISSION: "AFFILIATION_COMMISSION",
  AFFILIATION_UNIQUE_LINK: "AFFILIATION_UNIQUE_LINK",
  AFFILIATION_REGISTERED_REFERRALS: "AFFILIATION_REGISTERED_REFERRALS",
  AFFILIATION_TOTAL_EARNINGS: "AFFILIATION_TOTAL_EARNINGS",
  AFFILIATION_NO_AFFILIATES_FOUND: "AFFILIATION_NO_AFFILIATES_FOUND",
  AFFILIATION_EDIT: "AFFILIATION_EDIT",
  AFFILIATION_ADD: "AFFILIATION_ADD",
  AFFILIATION_CODE: "AFFILIATION_CODE",
  AFFILIATION_EMAIL_PLACEHOLDER: "AFFILIATION_EMAIL_PLACEHOLDER",
  AFFILIATION_CODE_PLACEHOLDER: "AFFILIATION_CODE_PLACEHOLDER",
  AFFILIATION_GENERATE: "AFFILIATION_GENERATE",
  AFFILIATION_PERCENTAGE_LABEL: "AFFILIATION_PERCENTAGE_LABEL",
  AFFILIATION_EDIT_SUCCESS: "AFFILIATION_EDIT_SUCCESS",
  AFFILIATION_CREATE_BTN: "AFFILIATION_CREATE_BTN",
  AFFILIATION_SAVE_BTN: "AFFILIATION_SAVE_BTN",
  AFFILIATION_UNKNOWN: "AFFILIATION_UNKNOWN",
  AFFILIATION_DELETE: "AFFILIATION_DELETE",
  AFFILIATION_DELETE_TEXT: "AFFILIATION_DELETE_TEXT",
  AFFILIATION_TYPE_USER: "AFFILIATION_TYPE_USER",
  AFFILIATION_TYPE_COMPANY: "AFFILIATION_TYPE_COMPANY",
} as const;
